<template>
  <div :class='"index_header index_header_page_"+page'>
    <div class="_wrapper">
      <h2>
        <router-link to="/index">
          <img v-if="logo" :src="logo">
          <img v-else src="../../../assets/images/logo2.png">
          {{title || '报名系统'}}
        </router-link>
      </h2>
      <ul>
        <li><router-link to="/index"><img src="../../../assets/images/btn_4.png">首 页</router-link></li>
        <li class="_line"><span> </span></li>
        <li><router-link to="/index/help">{{studentType === 2 ? '填报须知' : '帮 助'}}<img src="../../../assets/images/btn_5.png"></router-link></li>
      </ul>
    </div>
  </div>
</template>

<script>
  import IndexCommon from '../mixins/index_common';
  import config from "../../../../config";
  export default {
    props: {
      page: {
        type: String,
        default: ""
      },
    },
    mixins: [IndexCommon],
    components: {
    },
    data() {
      return {
        title: config.title,
        logo: config.web && config.web.logo
      };
    },
    created() {
    },
    methods: {}
  };
</script>

<style lang="stylus" scoped>
  .index_header {
    min-width 1200px
    height 100px;
    line-height 100px;
    background: linear-gradient(to left, #06D6B3 0%, #35B0C9 100%);
    &.index_header_page_home {
      background rgba(255, 255, 255, 0.3);
    }
    h2 {
      color #fff;
      font-size 30px;
      padding-left 5px;
      a {
        color #fff;
        img {
          position relative;
          height 60px;
        }
      }
    }
    ul {
      position absolute;
      top 0;
      right 0;
      color #fff;
      li {
        display inline-block;
        padding 0 25px;
        font-size 18px;
        font-weight 100;
        &._line {
          span {
            border-left 1px solid #fff
            width 1px
            padding 10px 0
            opacity .6
          }
        }
        a {
          color #fff;
          font-weight 300;
          &:hover {
            text-decoration underline
          }
          img {
            width 24px
            position relative
            top -2px
            margin 0 12px
          }
        }
      }
    }
  }
</style>
